import Dashboard from './Dashboard'
import Divisions from './Divisions'
import Channels from './Channels'
import Confirm from './Confirm'
import Content from './Content'
import Login from './Login'
import Secure from './Secure'
import Reset from './Reset'
import ResetConfirm from './ResetConfirm'
import Settings from './Settings'
import Share from './Share'
import Users from './Users'
import Viewer from './Viewer'
import NotFound from './NotFound'

export {
  Dashboard,
  Divisions,
  Channels,
  Confirm,
  Content,
  Login,
  Secure,
  Reset,
  ResetConfirm,
  Settings,
  Share,
  Users,
  Viewer,
  NotFound
}



// WEBPACK FOOTER //
// ./src/views/index.js